
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-insurance/join",
      function () {
        return require("private-next-pages/health-insurance/join/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-insurance/join"])
      });
    }
  